"use client";

import { c as _c } from "react/compiler-runtime";
import { Track } from "@opensea/analytics";
import { Button } from "@opensea/next-ui-kit";
import { classNames } from "@opensea/ui-kit";
import { Login, Logout } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useConnectFlow } from "@/hooks/use-connect-flow";
import { useDisconnect } from "@/hooks/use-disconnect";
import { useAddress } from "@/hooks/wallet";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuConnectItem(t0) {
  const $ = _c(35);
  let className;
  let isSheet;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      isSheet,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = isSheet;
    $[3] = onClick;
    $[4] = rest;
  } else {
    className = $[1];
    isSheet = $[2];
    onClick = $[3];
    rest = $[4];
  }
  const address = useAddress();
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      source: "More Menu"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const connectFlow = useConnectFlow(t1);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      source: "More Menu"
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const disconnect = useDisconnect(t2);
  const t = useTranslations("MoreMenuConnectItem");
  let t3;
  if ($[7] !== address) {
    t3 = address ? {
      event: "Logout Click",
      data: {
        source: "Logout More Menu"
      }
    } : {
      event: "Login Click",
      data: {
        source: "More Menu"
      }
    };
    $[7] = address;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = address && "text-error-1";
  let t5;
  if ($[9] !== className || $[10] !== t4) {
    t5 = classNames(t4, className);
    $[9] = className;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== address || $[13] !== connectFlow || $[14] !== disconnect || $[15] !== onClick) {
    t6 = async event => {
      if (address) {
        await disconnect({
          event
        });
      } else {
        connectFlow({
          event
        });
      }
      onClick?.(event);
    };
    $[12] = address;
    $[13] = connectFlow;
    $[14] = disconnect;
    $[15] = onClick;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== address || $[18] !== isSheet) {
    t7 = isSheet ? <Button className="text-inherit" icon={address ? Logout : Login} size="lg" variant="secondary" /> : <MoreMenuItemAvatar className="text-inherit" icon={address ? Logout : Login} />;
    $[17] = address;
    $[18] = isSheet;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== address || $[21] !== t) {
    t8 = address ? t("logoutTitle") : t("loginTitle");
    $[20] = address;
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t8) {
    t9 = <MoreMenuItemContent><MoreMenuItemTitle className="text-inherit">{t8}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== isSheet || $[26] !== rest || $[27] !== t5 || $[28] !== t6 || $[29] !== t7 || $[30] !== t9) {
    t10 = <MoreMenuItem className={t5} isSheet={isSheet} onClick={t6} {...rest}>{t7}{t9}</MoreMenuItem>;
    $[25] = isSheet;
    $[26] = rest;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t3) {
    t11 = <Track click={t3}>{t10}</Track>;
    $[32] = t10;
    $[33] = t3;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
}